<template>
	<div class="flexCol alit" style="width: 100%;min-height: 43vh;">
		<div class="" style="position: relative;cursor: pointer;width: 100%;" @click="goCompanyNews">
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/%E5%A4%B4%E9%83%A8.png"
				style="width: 100%;" alt="" />
		<!-- 	<div class="" style="position: absolute;right: 100px;top: 160px;text-align: right;">
				<h1 class="">新闻资讯</h1>
				<div class="">为您提供千广科技的最新新闻咨询</div>
			</div> -->
		</div>
		<div class="top-title">
			<div class="title">{{ pageData.title }}</div>
			<div class="flex justb">
				<!-- 来源：{{ pageData.source }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
				<!-- <div class="desc">发布时间：{{
					pageData.createTime }}</div>
				<div class="desc">浏览量：{{ pageData.browseCount }}</div> -->
			</div>
		</div>
		<img :src="pageData.picUrl" alt="" style="max-width: 70%;margin-bottom: 30px;" />
		<!-- <div class="content" v-html="pageData.content"></div> -->
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref
	} from 'vue'
	import {
		useRouter,useRoute 
	} from 'vue-router';
	const router = useRouter();
	const route = useRoute()
	const pageData = ref({
		title: '火锅界新风尚，天然食材引领健康食潮',
		createTime: '2024-10-28 15:48:39',
		browseCount: 666,
		content: '千广智慧农业，千广智慧农业千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，千广智慧农业，'
	})
	onMounted(() => {
		pageData.value = route.query
	})
	function goCompanyNews() {
		router.push('/companyNews')
	}
</script>

<style scoped>
	.content {
		width: 70%;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.desc {
		color: rgba(157, 157, 157, 1);
		font-size: 15px;
		margin-top: 30px;
	}

	.title {
		font-size: 32px;
		color: rgba(74, 74, 74, 1);
	}

	.top-title {
		padding: 20px 0;
		border-bottom: 1px solid rgba(194, 205, 215, 1);
		border-top: 1px solid rgba(194, 205, 215, 1);
		width: 70%;
	}
</style>